var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line-chart',{attrs:{"data":_vm.rawChartData,"tooltip-label-generator":_vm.tooltipLabelGenerator,"gradient":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }